// extracted by mini-css-extract-plugin
export var content = "_m8-1";
export var divider = "_m8-0";